angular.module("avant.customer_applications.controllers").controller "CustomerApplicationsPersonalContinuedCtrl", [
  "$scope", "$controller", "$cookies", "CustomerApplicationService", "ApplicationService", "$rootScope", "SmartyStreetsService",
  ($scope, $controller, $cookies, CustomerApplicationService, ApplicationService, $rootScope, SmartyStreetsService) ->
    autosuggested_address = {}
    $scope.page = "personal_continued"
    # $scope.person = { first_name: 'Not Bob' }

    $scope.$emit('customer_application:data', ApplicationService.data)
    # angular.extend($scope, ApplicationService.data)
    angular.extend($scope, $controller('CustomerApplicationsMixinCtrl', {$scope: $scope, CustomerApplicationService: CustomerApplicationService, ApplicationService: ApplicationService}))
    angular.extend($scope, $controller('SectionMixinCtrl', {$scope: $scope}))

    # The var name 'declinedOption' is being used until we refactor schumer box
    $scope.declinedOption = { data: ApplicationService.data.predecisioned_terms }
    $scope.showPromoCode = ($scope.promotions and $scope.promotions.length > 0) || $scope.isOrganic
    $scope.disableSSN = _.last(ApplicationService.viewable_pages) != $scope.page || $scope.customer_application.refinance
    $scope.disablePreapproved = $scope.config.disable_preapproved_fields
    $scope.hideAddPromoField = $scope.promotions and (typeof _.find($scope.promotions, (p) -> p.stop_rule_processing is true) isnt 'undefined')

    $scope.$on "$viewContentLoaded", ->
      # Track page view after test activates
      $scope.trackVisit()
      $scope.tealiumView("#{$scope.page}_view", { application_page: $scope.page })

    setAutosuggestAddress = (bool, address) ->
      ApplicationService.setAutosuggestAddress(bool) if autosuggested_address.suggested != bool
      autosuggested_address.suggested = bool
      autosuggested_address.address = address if address

    isAutosuggested = ->
      ($scope.customer_address.address_1.toLowerCase() != autosuggested_address.address.street_line.toLowerCase() || $scope.customer_address.city.toLowerCase() != autosuggested_address.address.city.toLowerCase() || $scope.customer_address.state.toLowerCase() != autosuggested_address.address.state.toLowerCase())

    $scope.getAddresses = (prefix) ->
      SmartyStreetsService.suggest(prefix)

    $scope.setAddress = (item) ->
      setAutosuggestAddress(true, item)
      $scope.customer_address.address_1 = item.street_line
      $scope.customer_address.city = item.city
      $scope.customer_address.state = item.state
      $scope.update("customer_address.city")
      $scope.update("customer_address.state")

    $scope.compareAutoSuggestAddress = ->
      return if autosuggested_address.suggested == false
      if( (!autosuggested_address.address) || isAutosuggested())
        setAutosuggestAddress(false, autosuggested_address.address)

    $scope.clearAll = ->
      $scope[ivar] = {} for ivar in $scope.ivars
      $scope.requirements = {}

    $scope.submit = ->
      ApplicationService.setAutosuggestAddress(autosuggested_address.suggested)
      $scope.$emit 'conversion:action', 'submit', 'personal_continued'
      $scope.submitWrapper (response_data) ->
        $scope.redirectIfDifferentPage response_data, ->
          # some error occurred as page didn't change
          if response_data.server_side_errors and response_data.server_side_errors.length > 0
            $scope.closeAllLoadingModals()
            $scope.showServerSideErrors(response_data.server_side_errors)
        true

    # Shuffle the acquisition channels, forcing Other to the end of the list.
    $scope.config.acquisition_channels.sort (a, b) ->
      return 1 if a == "Other"
      return -1 if b == "Other"
      return Math.random() - 0.5

    $scope.daysOfMonth = _.map Array(31), (e,i) -> i + 1

    $scope.popover = ($event) ->
      $event.preventDefault()
      target = angular.element($event.target || $event.which)
      target.popover trigger: "hover"
      return

]
